﻿<template>
    <validation-provider :name="name" :rules="validateRules" :debounce="debounce" v-slot="validation" mode="eager" slim>
        <div class="form-group">
            <label :for="'input'+_uid" :class="styleLabel">{{name}}</label>
            <div :class="styleInput">
                <div class="input-group" v-if="required">
                    <masked-input class="form-control"
                                  v-bind:class="{'is-invalid': validation.invalid && validation.validated, 'is-valid': validation.valid && validation.validated &&  displaySuccessValidation }"
                                  type="text"
                                  :mask="mask"
                                  :guide="guide"
                                  placeholderChar="#"
                                  :keepCharPositions="true"
                                  :id="'input'+_uid"
                                  :name="'input'+_uid"
                                  :placeholder="name"
                                  v-model="internalValue">
                    </masked-input>
                    <div class="input-group-append">
                        <span class="input-group-text"><i class="fas fa-asterisk" title="Required Field"></i></span>
                    </div>
                </div>
                    <masked-input class="form-control"
                                  v-bind:class="{'is-invalid': validation.invalid && validation.validated, 'is-valid': validation.valid && validation.validated &&  displaySuccessValidation}"
                                  type="text"
                                  :mask="mask"
                                  :guide="guide"
                                  placeholderChar="#"
                                  :keepCharPositions="true"
                                  :id="'input'+_uid"
                                  :name="'input'+_uid"
                                  :placeholder="name"
                                  v-model="internalValue"
                                  v-if="!required">
                    </masked-input>
                    <span class="invalid-feedback d-block" v-for="err in validation.errors">{{err}}</span>
                </div>
        </div>
    </validation-provider>    
</template>

<script>    
    var maskedInput = require('vue-text-mask');
    module.exports = {       
        components: {
            maskedInput: maskedInput.default,
            validationProvider: VeeValidate.ValidationProvider
        },
        props: {
            name: {
                type: String,
                required: true
            },
            value: {
                type: String,
                default: ''
            },
            required: {
                type: Boolean,
                default: false
            },
            labelCols: {
                type: Number,
                default: 4
            },
            mask: {                
                default: []
            },
            validationRules: {
                type: Object,
                default: function () { return {} }
            },
            displaySuccessValidation: {
                type: Boolean,
                default: false
            },
            debounce: {
                type: Number,
                default:0
            },
            guide: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            validateRules: function () {
                var res = { required: this.required };
                Object.assign(res, this.validationRules);                
                return res;
            },
            styleLabel: function () {
                if (this.labelCols > 0) {
                    return 'col-sm-' + this.labelCols + ' control-label';
                }
                return 'control-label';
            },
            styleInput: function () {
                if (this.labelCols > 0) {
                    return 'col-sm-' + (12 - this.labelCols);
                }
                return '';
            },
            internalValue: {
                get: function() {
                    return this.value;
                },
                set: function(val) {
                    var formattedValue = val;
                    this.$emit('input', formattedValue);
                }
            }
        }
    }
</script>